export default "__VITE_ASSET__DUL_CKSO__"